/**
 * Route for `linkedin-conversions-api`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { LinkedinConversionsApiPage } from "../features/linkedin-conversions-api/LinkedinConversionsApiPage";

export const linkedinConversionsApiRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/linkedin-conversions-api",
	component: LinkedinConversionsApiPage,
});

export default linkedinConversionsApiRoute;
